import { Box } from '@mantine/core';
import { useId } from 'react';

import type { IconPropsType } from './types';

export const FlagUkIcon = ({ size = 24, sx, ...props }: IconPropsType) => {
  const id = useId();

  return (
    <Box
      component="svg"
      sx={sx}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath={`url(#${id})`}>
        <g clipPath={`url(#${id})`}>
          <path d="M156.24 -64H-133V88.61H156.24V-64Z" fill="#005BBB" />
          <path
            d="M156.24 12.3096H-133V88.6196H156.24V12.3096Z"
            fill="#FFD500"
          />
        </g>
      </g>
      <defs>
        <clipPath id={id}>
          <rect width="24" height="24" rx="12" fill="white" />
        </clipPath>
        <clipPath id={id}>
          <rect
            width="289.24"
            height="152.61"
            fill="white"
            transform="translate(-133 -64)"
          />
        </clipPath>
      </defs>
    </Box>
  );
};
